var React = require( 'react' );
var createReactClass = require('create-react-class');

var LinkWrapper = function(Component) {
    return createReactClass({

        handleClick: function(e) {
            var label = this.props.label || this.props.to;
            var action = this.props.action || e.currentTarget.innerText;
            this.props.onClick && this.props.onClick(e);
            this.props.handler(action, label);
        },

        render: function() {
            return (
                <Component id={this.props.id} className={this.props.className} to={this.props.to} onClick={this.handleClick}>{this.props.children}</Component>
            );
        }
    });
};

module.exports = LinkWrapper;



// WEBPACK FOOTER //
// ./src/common/routes/components/linkWrapper.jsx